import { cn } from '@merels/ui'
import { useSignals } from '@preact/signals-react/runtime'

import { mateListTestIds } from '../../list/MateList/mateList.testIds'

export interface PlayingAsIndicatorProps {
  currentPlayerId: string
  shouldUsePlayerColors: boolean
  currentPlayerIndex: number | null
  getPlayerColor: (playerIndex: number) => { primary: string; foreground: string } | null
}

/**
 * PlayingAsIndicator renders the small "Playing as <playerId>" row in the mate list sidebar.
 *
 * In Omni mode with exactly 2 players, text uses the current player's theme color.
 * No borders — white seats made the old bordered box look like chalk outlines.
 */
export function PlayingAsIndicator({
  currentPlayerId,
  shouldUsePlayerColors,
  currentPlayerIndex,
  getPlayerColor,
}: PlayingAsIndicatorProps) {
  useSignals()

  const currentPlayerColor = currentPlayerIndex !== null ? getPlayerColor(currentPlayerIndex) : null

  const textStyle = shouldUsePlayerColors && currentPlayerColor
    ? { color: currentPlayerColor.foreground }
    : undefined

  return (
    <div className="px-2 py-2">
      <div
        data-testid={mateListTestIds.playingAsIndicator}
        className={cn(
          'text-xs font-medium',
          shouldUsePlayerColors ? undefined : 'text-muted',
        )}
        style={textStyle}
      >
        Playing as {currentPlayerId}
      </div>
    </div>
  )
}
